<template>
  <div class="verification-body">
    <img src="@/assets/images/Logo_A_White.png" alt="" style="width: 12.8em">
    <div class="fc-FFFFFF fw-900 mt-32" style="font-size: 1.8em">
      <div>Thank you for reporting this issue,</div>
      <div>FirstName.</div>
    </div>
    <div class="text-container">
      <div>
        <div class="header">Why do we do this?</div>
        <div class="description">
          <div>
            Being a proactive manager is effortful and impactful. We want your
            efforts to be recognized.
          </div>
          <div>&nbsp;</div>
          <div>
            It looks like your email client is limiting our ability to recognize
            you for reading your team’s insights.
          </div>
        </div>
      </div>
      <div class="mt-24" v-if="!trackOpen">
        <div class="header">What we’ll do</div>
        <div class="description">
          <div>
            Since we cannot account for insights that you view, your open rate
            will display as “N/A” (Not Available) in your reports.
          </div>
        </div>
      </div>
      <div class="mt-24" v-else>
        <div class="header">What we’ll do</div>
        <div class="description">
          <div>
            We will count your most recent email open as read and will continue
            to monitor the situation.
          </div>
        </div>
      </div>
    </div>
    <div class="fs-14" style="color: #ffc200">
      Thank you for being attentive to your team.
    </div>
  </div>
</template>

<script>
import CryptoJS from "crypto-js";
export default {
  name: "verify-email-report",
  data() {
    return {
      email: "",
      quest_id: "",
      dateInput: "",
    };
  },
  created() {   
    
    let bytes = CryptoJS.AES.decrypt(
      this.$route.params.id,
      "REPORT_DAILY_TRACK_OPEN"
    );
     
    let originalText = bytes.toString(CryptoJS.enc.Utf8);
    if (originalText) {
      let codeSplit = originalText.split("||");

      const value = codeSplit[0]+"-"+codeSplit[2]+"-"+codeSplit[1] ;
      this.$store.dispatch("verifyemailreport/updateOpen", value);
    } else {
      console.warn("Don't have any ID");
     
    }
  },
   computed:{
 trackOpen() {
      return this.$store.getters["verifyemailreport/trackOpen"];
    },
  },
  methods: {

  },
};
</script>

<style lang="scss" scoped>
.verification-body {
  background-color: #4c32cc;
  padding: 60px 0;
  min-width: 100vw;
  min-height: calc(100vh - 120px);
  text-align: center;
  font-size: 62.5%;

  @media only screen and (max-width: 480px) {
    font-size: 58%;
  }

  @media only screen and (max-width: 320px) {
    font-size: 52%;
  }
}
.text-container {
  width: calc(100% - 48px);
  max-width: 360px;
  margin: 32px auto;
  background-color: rgba($color: #000000, $alpha: 0.25);
  padding: 42px 24px;
  .header {
    color: #fff;
    font-size: 1.4em;
    font-weight: 900;
  }
  .description {
    color: #fff;
    font-size: 1.4em;
    margin-top: 6px;
  }
}
</style>